//**auto-generated don't edit this code**//
import {ContractHttpClient, getClientConfig} from '@esgi/contracts';
import {Disposable} from '@esgi/core/service';
import {initCreate} from './endpoints/init-create';
import {initEdit} from './endpoints/init-edit';
import {create} from './endpoints/create';
import {update} from './endpoints/update';
import {remove} from './endpoints/remove';

export class V2SchoolAdminsClassesController implements Disposable {
	private httpClientConfig = getClientConfig('esgi-apigateway');
	private httpClient: ContractHttpClient = new ContractHttpClient(this.httpClientConfig);

	public initCreate = initCreate(this.httpClient);
	public initEdit = initEdit(this.httpClient);
	public create = create(this.httpClient);
	public update = update(this.httpClient);
	public remove = remove(this.httpClient);

	public dispose(): void {
		this.httpClient?.destroy();
	}
}
